<template>
  <div
    @click="isChecked"
    :style="this.selectedValue == this.id ? isActiveStyle : ''"
    class="w-checkbox donation-grid-price-item"
  >
    <span class="checkbox-label w-form-label">{{ value }}</span>
  </div>
</template>
<script>
export default {
  props: ["value", "id", "selectedValue"],

  data: () => {
    return {
      isActiveStyle: "background-color:#3898EC; color:white",
    }
  },
  methods: {
    async isChecked() {
      await this.$emit("update", this.id)
      await this.$emit("update:modelValue", this.id)
    },
  },
}
</script>

<style scoped>
.w-checkbox {
  cursor: pointer;
}
</style>
